<template>
    <div>
        <!--业务咨询弹窗-->
        <Modal v-model="modalFade" class-name="consultation-modal" :width="550" @on-visible-change="modalChange">
            <p slot="header">
                <Icon type="information-circled"></Icon>
                <span>欢迎咨询</span>
            </p>
            <div class="consultation-form-wrapper">
                <Form ref="consultationForm" :model="consultationForm" :label-width="75" label-position="left" :rules="consultationRules">
                    <FormItem prop="portDistrict" label="港口">
                        <CheckboxGroup v-model="consultationForm.portDistrict" @on-change="changePort">
                            <Checkbox label="上海港"></Checkbox>
                            <Checkbox label="宁波港"></Checkbox>
                            <Checkbox label="青岛港"></Checkbox>
                            <Checkbox label="太仓港"></Checkbox>
                            <Checkbox label="深圳港"></Checkbox>
                            <Checkbox label="其他"></Checkbox>
                        </CheckboxGroup>
                        <Input v-if="showOtherPortInput" v-model="consultationForm.otherPortDistrict" placeholder="请输入其他港口"></Input>
                    </FormItem>
                    <FormItem prop="boundType" label="业务类型">
                        <CheckboxGroup v-model="consultationForm.boundType" @on-change="changeType">
                            <Checkbox label="进口"></Checkbox>
                            <Checkbox label="出口"></Checkbox>
                            <Checkbox label="其他"></Checkbox>
                        </CheckboxGroup>
                        <Input v-if="showOtherTypeInput" v-model="consultationForm.otherBoundType" placeholder="请输入其他业务类型"></Input>
                    </FormItem>
                    <FormItem prop="doorArea" label="门点区域">
                        <!-- <AutoComplete v-model="consultationForm.doorArea" :data="doorAreas" @on-search="searchDoorAreas" placeholder="请输入工厂门点">
                        </AutoComplete> -->
                        <Cascader v-model="consultationForm.doorArea" :data="doorAreas" filterable></Cascader>
                    </FormItem>
                    <FormItem prop="requirements" label="备注">
                        <Input type="textarea" :autosize="{minRows: 3,maxRows: 6}" v-model="consultationForm.requirements">
                        </Input>
                    </FormItem>
                    <FormItem prop="companyName" label="公司名称">
                        <Input v-model="consultationForm.companyName" placeholder="请输入公司名称">
                        </Input>
                    </FormItem>
                    <FormItem prop="contactPerson" label="称谓">
                        <Input v-model="consultationForm.contactPerson" placeholder="请输入称谓">
                        </Input>
                    </FormItem>
                    <FormItem prop="contactMobilePhone" label="联系方式">
                        <Input v-model="consultationForm.contactMobilePhone" placeholder="请输入手机">
                        </Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type="primary" size="large" @click="submitConsultationInfo('consultationForm')" :loading="loading">提交</Button>
            </div>
        </Modal>
        <Modal v-model="successModal.fade" style="text-align: center;" :mask-closable="false" width='300'>
            <p style="margin-bottom: 10px;">
                <Icon type="checkmark-circled" size="60" color="#19be6b"></Icon>
            </p>
            <h1>提交成功</h1>
            <p style="font-size: 16px;">请耐心等待客服人员回访</p>
            <p style="font-size: 16px;">感谢您的支持！</p>
            <div slot="footer">
                <Button type="primary" size="large" long @click="successModal.fade = false">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';
    import axios from 'axios';
    import util from '../libs/util';
    import city from '../static/city'
    export default {
        props: {
            fade: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showOtherPortInput: false,
                showOtherTypeInput: false,
                modalFade: false,
                // 咨询弹窗form绑定信息
                consultationForm: {
                    companyName: '',
                    contactPerson: '',
                    contactMobilePhone: '',
                    boundType: [],
                    doorArea: [],
                    portDistrict: [],
                    requirements: '',
                    otherPortDistrict: '',
                    otherBoundType: ''
                },
                // 咨询弹窗form绑定信息验证
                consultationRules: {
                    companyName: [
                        {
                            required: true,
                            message: '请输入您的公司名称',
                            trigger: 'blur'
                        }
                    ],
                    contactPerson: [
                        {
                            required: true,
                            message: '请输入您的称谓',
                            trigger: 'blur'
                        }
                    ],
                    contactMobilePhone: [
                        {
                            required: true,
                            message: '请输入您的手机',
                            trigger: 'blur'
                        }
                    ]
                },
                // 门点区域信息
                doorAreas: "",
                // 记录匹配出的门点区域
                doorAreasMatched: "",
                // 门点区域输入框输入值长度
                lengthOfInputValue: 0,
                // 业务咨询提交完成提示
                successModal: {
                    fade: false
                },
                loading: false
            };
        },
        created() {
            this.getDoorAreas()
        },
        computed: {
        },
        watch: {
            fade(val) {
                if(val) this.getDoorAreas()
                this.modalFade = util.deepClone(val)
            }
        },
        methods: {
            // 打开咨询弹窗
            // openConsultationModal() {
            //     this.fade = true;
            // },
            // 从后台获取港区数据
            getDoorAreas() {
                // util.ajax_get(this, '/harbour-server/data/door_area', {}, response => {
                //     response.data.doorAreas.forEach(item => {
                //         item.pinyin = util.pinyin.get(item.name)
                //     })
                //     this.doorAreasRes = response.data.doorAreas;
                //     this.doorAreasMatched = util.deepClone(this.doorAreasRes);
                // });
                console.log(typeof city)
                let cityData = city
                this.doorAreas = cityData
                this.doorAreas.forEach(item => {
                    item.value = item.label
                    item.children.forEach(initem => {
                        initem.value = initem.label
                    })
                })
                // console.log(this.doorAreas)
            },
            // 搜索门点区域
            searchDoorAreas(value) {
                console.log(value)
                if (!value) {
                    this.doorAreas = [];
                    return;
                }
                if (this.lengthOfInputValue > value.length) {
                    this.doorAreasMatched = util.deepClone(this.doorAreasRes);
                }
                this.lengthOfInputValue = value.length;
                let doorAreas = [];
                let doorAreasMatched = [];
                this.doorAreasMatched.forEach(elem => {
                    if(doorAreas.length > 10) return
                    if(elem.pinyin){
                        let short = util.pinyin.returnCaps(elem.pinyin);
                        if (
                            elem.name.indexOf(value) !== -1 ||
                            elem.pinyin.toUpperCase().indexOf(value.toUpperCase()) !==
                            -1 ||
                            short.toUpperCase().indexOf(value.toUpperCase()) !== -1
                        ) {
                            doorAreas.push(elem.name);
                            doorAreasMatched.push(elem);
                        }
                    }
                });
                this.doorAreas = util.deepClone(doorAreas);
                this.doorAreasMatched = util.deepClone(doorAreasMatched);
            },
            // 提交咨询信息
            submitConsultationInfo(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        let portDistrict = ''
                        let boundType = ''
                        let req = util.deepClone(this.consultationForm);
                        // if (req.boundType) {
                        //     req.boundType = req.boundType === '进口' ? 'IB' : 'OB';
                        // }
                        if (req.otherPortDistrict != '') {
                            req.portDistrict.push(req.otherPortDistrict)
                            let index = req.portDistrict.indexOf('其他')
                            req.portDistrict.splice(index,1)
                        } else {
                            delete req.otherPortDistrict
                        }

                        if (req.otherBoundType != '') {
                            req.boundType.push(req.otherBoundType)
                            let index = req.boundType.indexOf('其他')
                            req.boundType.splice(index,1)
                        } else {
                            delete req.otherBoundType
                        }

                        req.portDistrict = req.portDistrict.toString()
                        req.boundType = req.boundType.toString()
                        req.area = req.doorArea.toString().replace(',','-')
                        console.log(req)
                        this.loading = true
                        util.ajax_post(this, '/harbour-server/duckBill/customerConsultion/add', req, response => {
                            this.loading = false
                            if (response.data.success) {
                            _hmt.push(['_trackEvent', '用户未登录', 'click', '业务咨询提交成功'])
                            // this.$Message.info('提交成功');
                            this.successModal.fade = true;
                            this.modalChange(false)
                            this.$refs[name].resetFields();
                        }
                    });
                    } else {
                        this.$Message.error('必填信息为空');
                    }
                });
            },
            modalChange(val) {
                // this.fade = val;
                if(!val) this.$emit('change', val)
            },

            // 更新选择港口
            changePort(val) {
                val.includes('其他') ? this.showOtherPortInput = true : this.showOtherPortInput = false;
            },

            // 更新选择业务类型
            changeType(val) {
                val.includes('其他') ? this.showOtherTypeInput = true : this.showOtherTypeInput = false;
            }
        }
    };
</script>

<style lang='less'>
    @import '../styles/common.less';
</style>



// WEBPACK FOOTER //
// consultation-modal.vue?a48f1942